module.exports = __webpack_public_path__ + "img/homeDone2.fd16dbfb.png";